// =============================================================================
//  LOGO ASSETS  —  swap to your real artwork here in ONE place.
//
//  To use your attached PNG logo:
//   1) Save the full logo as:  public/logo.png
//   2) Save just the "M" mark as:  public/logo-mark.png
//   3) Change ".svg" to ".png" on the two lines below.
//  (The provided .svg files are brand-matched fallbacks so the app runs now.)
// =============================================================================
const base = process.env.PUBLIC_URL || "";

export const LOGO = `${base}/logo.png`;        // full logo (Connect screen)
export const LOGO_MARK = `${base}/logo.png`;   // mark (loader, top bar, favicon)
